import initialState from 'reducers/initialState';
import * as types from 'features/offer/edit/decision/financedChart/actionTypes';
import * as events from 'features/offer/edit/decision/financedChart/eventTypes';

const financedChartReducer = (state = initialState.document.decision.financedChart, action) => {
  switch (action.type) {
    case types.LOAD_OFFER_DECISION_FINANCED_ASSETS_CHART_STARTED: {
      const key = `${action.payload.documentId}-${action.payload.siteId}`;
      return {
        ...state,
        [key]: {
          ...state[key],
          loading: true
        }
      };
    }
    case types.LOAD_OFFER_DECISION_FINANCED_ASSETS_CHART_SUCCESS: {
      const key = `${action.payload.documentId}-${action.payload.siteId}`;
      return {
        ...state,
        [key]: {
          ...state[key],
          isLoaded: true,
          loading: false
        }
      };
    }
    case events.OFFER_DECISION_FINNANCING_ASSETS_CHART_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: { ...state[key], isLoaded: false, loading: false }
      };
    }

    default:
      return state;
  }
};

export default financedChartReducer;
